export default "__VITE_ASSET__7f05cfbc__"